import {
    BillingIdentifier,
    BalanceDetails,
    SingleBillingDetails,
    ProfessionalBillingDetails,
} from 'one-state-billing-identifier';

import {format} from 'one-util-date'; 

export const TransformBillingDetails = (response: any, context: any,  patientid?: any) => {

    let billingdata: Billing[] = [];
    let billingresult: any = {
        billingdata: billingdata,
        error: undefined

    }
    const { log,settings } = context;
    const {uisettings:{dateformat}} = settings
    log.debug("one-epic", "TransformBillingDetails transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        billingresult.error = response;
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            if (ele?.GuarantorAccounts?.length > 0) {
                ele.GuarantorAccounts.map((account: any) => {
                    let billing: BillingIdentifier = {
                        serviceAreaName: "",
                        patientsGuarantor: false,
                        paperless: false,
                        AccountId: "",
                        AccountName: "",
                        patientid:"",
                        balanceDetails: undefined,
                        singleBillingDetails: undefined,
                        professionalBillingDetails: undefined,
                    };

                    let balancelist: BalanceDetails[] = [];
                    let singlebillinglist: SingleBillingDetails[] = [];
                    let professionalbillinglist: ProfessionalBillingDetails[] = [];

                    billing.serviceAreaName = account?.ServiceArea?.Name;
                    billing.patientsGuarantor = account?.PatientIsGuarantor;
                    billing.paperless = account?.IsPaperless;
                    billing.patientid = patientid? patientid : "";
                    if (account?.AccountIDs) {
                        account.AccountIDs.map((element: any) => {
                            if (element.Type === 'INTERNAL') {
                                billing.AccountId = element?.ID;
                            }
                            if (element.Type === 'NAME') {
                                billing.AccountName = element?.ID;
                            }
                        })
                    }

                    if (account?.SingleBillingOffice?.OutstandingAccount) {
                        let sboobj: BalanceDetails = {
                            type: "SBO",
                            patientBalance: account?.SingleBillingOffice?.OutstandingAccount?.PatientBalance,
                            insuranceBalance: account?.SingleBillingOffice?.OutstandingAccount?.InsuranceBalance,
                        }
                        balancelist.push(sboobj);
                    }

                    if (account?.ProfessionalBilling?.TransactionSummary || account?.HospitalBilling?.OutstandingAccount) {
                        let pbhbobj: BalanceDetails = {
                            type: "PB/HB",
                            patientBalance: "",
                            insuranceBalance: "",
                        }
                        let patientbal: any = 0;
                        let insurancebal: any = 0;
                        if (account?.ProfessionalBilling?.TransactionSummary) {
                            patientbal = patientbal + account?.ProfessionalBilling?.TransactionSummary?.PatientBalance ?
                                account?.ProfessionalBilling?.TransactionSummary?.PatientBalance : 0;
                            insurancebal = insurancebal + account?.ProfessionalBilling?.TransactionSummary?.InsuranceBalance ?
                                account?.ProfessionalBilling?.TransactionSummary?.InsuranceBalance : 0;
                        }
                        if (account?.HospitalBilling?.OutstandingAccount) {
                            patientbal = patientbal + account?.HospitalBilling?.OutstandingAccount?.PatientBalance ?
                                account?.HospitalBilling?.OutstandingAccount?.PatientBalance : 0;
                            insurancebal = insurancebal + account?.HospitalBilling?.OutstandingAccount?.InsuranceBalance ?
                                account?.HospitalBilling?.OutstandingAccount?.InsuranceBalance : 0;
                        }
                        pbhbobj.patientBalance = patientbal;
                        pbhbobj.insuranceBalance = insurancebal;
                        balancelist.push(pbhbobj);
                    }
                    if (account?.SingleBillingOffice?.OutstandingAccount?.Accounts) {
                        account.SingleBillingOffice.OutstandingAccount.Accounts.map((sbo: any) => {
                            let sboobj: SingleBillingDetails = {
                                admitdate: sbo?.AdmitDate ? format(sbo.AdmitDate,dateformat): "",
                                accountname: sbo?.HospitalAccountName,
                                locationname: sbo?.LocationName,
                                servicetype: sbo?.HospitalService ? 'Hospital' : (sbo?.ProfessionalService ? 'Professional' : ""),
                                patientbalance: sbo?.PatientBalance ? "$" + sbo?.PatientBalance : "$0.00",
                                insurancebalance: sbo?.InsuranceBalance ? "$" + sbo?.InsuranceBalance : "$0.00",
                            }
                            singlebillinglist.push(sboobj);
                        })
                    }
                    if (account?.ProfessionalBilling?.TransactionSummary?.Patients &&
                        account?.ProfessionalBilling?.TransactionSummary?.Patients?.length > 0) {
                        account.ProfessionalBilling.TransactionSummary.Patients.map((pat: any) => {
                            if (pat?.Visits &&
                                pat?.Visits?.length > 0) {
                                pat.Visits.map((visit: any) => {
                                    if (visit?.Charges &&
                                        visit?.Charges?.length > 0) {
                                        visit.Charges.map((pbhb: any) => {
                                            let phpbobj: ProfessionalBillingDetails = {
                                                code: pbhb?.Code,
                                                date: pbhb?.Date ? format(pbhb.Date,dateformat)  : "",
                                                departmentname: pbhb?.DepartmentName,
                                                description: pbhb?.Description,
                                                providername: pbhb?.ProviderName,
                                                patientbalance: pbhb?.PatientAmount ? "$" + pbhb?.PatientAmount : "$0.00",
                                                insurancebalance: pbhb?.InsuranceAmount ? "$" + pbhb?.InsuranceAmount : "$0.00",
                                            }
                                            professionalbillinglist.push(phpbobj);
                                        })
                                    }
                                })
                            }
                        })
                    }
                    if (account?.HospitalBilling?.OutstandingAccount?.Accounts) {
                        account?.HospitalBilling?.OutstandingAccount?.Accounts.map((pbhb: any) => {
                            let phpbobj: ProfessionalBillingDetails = {
                                code: "",
                                date: pbhb?.AdmitDate ? format(pbhb.AdmitDate,dateformat) : "",
                                departmentname: pbhb?.LocationName,
                                description: Array.isArray(pbhb?.Description) ? pbhb?.Description[0] : "",
                                providername: pbhb?.HospitalAccountName,
                                patientbalance: pbhb?.PatientBalance ? "$" + pbhb?.PatientBalance : "$0.00",
                                insurancebalance: pbhb?.InsuranceBalance ? "$" + pbhb?.InsuranceBalance : "$0.00",
                            }
                            professionalbillinglist.push(phpbobj);
                        })
                    }
                    billing.balanceDetails = balancelist;
                    billing.singleBillingDetails = singlebillinglist;
                    billing.professionalBillingDetails = professionalbillinglist;

                    billingdata.push(billing);
                })
            }
        });
    }
    billingresult.billingdata = billingdata;
    log.debug("one-epic", "TransformBillingDetails transformation Completed", billingresult);
    return billingresult;
}